import React, { createContext, useEffect } from 'react';
import { Dispatch } from 'redux';
import { useDispatch } from 'react-redux';
import { locale, loadMessages } from 'devextreme/localization';
import { useBeforeMount } from '@core/hooks';
import plMessages from './messages/pl.json';

// devExtreme
import themes from 'devextreme/ui/themes';

// hooks
import {
  useScreenHandler,
  useScreenSizeClass,
  ScreenSize
} from './hooks/useScreenHandler';

// redux
import { getWithDevExtremeModule } from './redux/module';
import {
  toggleThemeLight,
  toggleThemeDark,
  toggleThemeLightCompact,
  toggleThemeDarkCompact,
  ThemeActionPayload
} from './redux/actions';

export const handleThemes = (dispatch: Dispatch) => {
  const lsTheme = window.localStorage.getItem('dx-theme');

  if (lsTheme) {
    themes.current(lsTheme);
  }

  if (themes.current() === ThemeActionPayload.LIGHT_THEME) {
    dispatch(toggleThemeLight());
  } else if (themes.current() === ThemeActionPayload.DARK_THEME) {
    dispatch(toggleThemeDark());
  } else if (themes.current() === ThemeActionPayload.LIGHT_COMPACT_THEME) {
    dispatch(toggleThemeLightCompact());
  } else if (themes.current() === ThemeActionPayload.DARK_COMPACT_THEME) {
    dispatch(toggleThemeDarkCompact());
  }
};

interface DevExtremeContextValue {
  screenSize: ScreenSize;
}

export const DevExtremeContext = createContext<DevExtremeContextValue>({
  screenSize: {
    isXSmall: false,
    isSmall: false,
    isMedium: false,
    isLarge: true
  }
});

const withDevExtreme = (WrappedComponent: React.FC<any>) => (
  props: unknown
) => {
  useBeforeMount(() => {
    loadMessages(plMessages);
    locale(navigator.language);
  });

  const dispatch = useDispatch();

  const screenSize = useScreenHandler();

  const screenSizeClass = useScreenSizeClass(screenSize);

  useEffect(() => {
    handleThemes(dispatch);
  }, []);

  return (
    <DevExtremeContext.Provider value={{ screenSize }}>
      <div className={`app dx-theme-background-color ${screenSizeClass}`}>
        <WrappedComponent {...props} />
      </div>
    </DevExtremeContext.Provider>
  );
};

export const MwithDevExtreme = {
  hoc: withDevExtreme,
  reduxModules: [getWithDevExtremeModule()]
};

export default withDevExtreme;
